import React, { useState, useEffect } from 'react';
import _ from 'lodash';
import { Button, Icon } from '@tencent/spaui';
import { RPCFactory } from '../../../utils/RequestUtil';

const Page = (props) => {
  const [dataList, setDataList] = useState([]);

  useEffect(() => {
    RPCFactory.fansManagement.list().done((data) => {
      if (_.isArray(data)) {
        setDataList(data);
      }
    });
    // setDataList([
    //     {
    //         headImg: 'http://f.gdt.isd.com/gdt_ui_proj/dist/test-img/lp.jpg',
    //         nickName: '中邮速递易',
    //         isAuth: true,
    //         principalName: '中邮智递科技有限公司',
    //         authorizeTime: '2019.09.10',
    //     }
    // ])
  }, []);

  const onAdd = () => {
    RPCFactory.fansManagement
      .authorize()
      .done((data) => {
        const redirectUrl = `${window.location.origin + window.location.pathname}#/fan/official/offocialAccountsAuth`;
        const uri = data.url + encodeURIComponent(redirectUrl);
        console.log(encodeURIComponent(redirectUrl));
        window.open(uri, '_blank');
      })
      .fail((status, msg) => {
        alert(msg);
      });
  };

  const renderContent = () => (
    <div className="shouquan">
      <div className="toolbars">
        <div className="toolbar table-toolbar">
          <div className="toolbar-left">
            <Button displayType="primary" onClick={onAdd}>
              <Icon type="add" />
              新增授权
            </Button>
            <span className="btn-tips">
              支持授权已认证的服务号，如需解除授权，请进入微信公众号平台，在“公众号设置” 模块操作解除。
            </span>
          </div>
        </div>
      </div>
      <div className="imp-cards clearfix">
        {dataList.map((ele) => {
          const { nickName = '', headImg = '', verifyType, serviceType, principalName, authorizeTime } = ele || {};

          const time = new Date(authorizeTime)
            .toLocaleDateString()
            .split('/')
            .join('-');
          return (
            <div className="imp">
              <span className="sg">{serviceType == 2 ? '服务号' : '订阅号'}</span>
              <div className="img">
                <img src={headImg} alt="" />
              </div>
              <div className="wd-info">
                <p className="name">{nickName}</p>
                <p className="name-tip">
                  <span className="rz rz-on">{verifyType == 0 ? '已认证' : '未认证'}</span>
                  {principalName}
                </p>
                <p className="time">{`绑定时间:${time}`}</p>
              </div>
              {/* <div class="jiebang">
                                        <div class="mask"></div>
                                        <Button displayType='primary'>解除绑定</Button>
                                    </div> */}
            </div>
          );
        })}
      </div>
    </div>
  );

  return (
    <main className="main" id="main">
      <div className="card card-set-height">
        <div id="datarea">{renderContent()}</div>
      </div>
    </main>
  );
};

export default Page;
